import {instantDeliveryIds} from '@stubhub/delivery-utils';

import {
  electronicTicketMatchIds,
  mobileTicketMatchIds,
  mobileTransferMatchIds,
  paperTicketMatchIds,
} from '../../../../utils/constants';

export const All = {
  name: 'all',
  displayName: 'All tickets',
};

export const KEY_ALL = 'all';
export const KEY_PAPER = 'paper';
export const KEY_ELECTRONIC = 'electronic';
export const KEY_MOBILE = 'mobile';
export const KEY_MOBILE_TRANSFER = 'mobileTransfer';
export const KEY_INSTANT = 'instant';

export const LABELS_ID_MAPPING = {
  [KEY_ALL]: [],
  [KEY_PAPER]: paperTicketMatchIds,
  [KEY_ELECTRONIC]: electronicTicketMatchIds,
  [KEY_MOBILE]: mobileTicketMatchIds,
  [KEY_MOBILE_TRANSFER]: mobileTransferMatchIds,
  [KEY_INSTANT]: instantDeliveryIds,
};

export const IDS_LABELS_MAPPING = (() => {
  const keys = Object.keys(LABELS_ID_MAPPING);

  const result = keys.reduce((acum, key) => {
    LABELS_ID_MAPPING[key].forEach((id) => {
      acum[id] = [...(acum[id] || []), key];
    });

    return acum;
  }, {});

  return result;
})();

export function getArrayIntersectionByKeys(labelsArray) {
  const totalSet = getSelectedIdsByKey(labelsArray);
  const dupeMap = {};
  const result = [];
  totalSet.forEach((id) => {
    if (dupeMap[id] && dupeMap[id] === 1) {
      result.push(id);
      dupeMap[id]++;
    } else {
      dupeMap[id] = 1;
    }
  });

  return result;
}

export function getSelectedIdsByKey(labelsArray) {
  let result = [];
  labelsArray.forEach((label) => {
    result = result.concat(LABELS_ID_MAPPING[label]);
  });

  return result;
}

export function lookupArrayIntersections(array1, array2) {
  const lookupIds = array1;
  const reduceSet = [];
  lookupIds.forEach((id) => {
    if (array2.indexOf(id) >= 0) {
      reduceSet.push(id);
    }
  });

  return reduceSet;
}

export const INSTANT_DELIVERY_TYPES = [KEY_INSTANT, KEY_MOBILE, KEY_ELECTRONIC];
